module.exports = __webpack_public_path__ + "static/media/pantone-outline.ca5acc0d.svg";